import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Defer to allow target sections to mount
      const tries = [0, 100, 300, 600];
      let done = false;
      const timers: number[] = [];
      tries.forEach((delay) => {
        const t = window.setTimeout(() => {
          if (done) return;
          const el = document.getElementById(id);
          if (el) {
            done = true;
            const top = el.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: "smooth" });
            el.setAttribute("data-highlight", "true");
            window.setTimeout(() => el.removeAttribute("data-highlight"), 1700);
          }
        }, delay);
        timers.push(t);
      });
      return () => timers.forEach((t) => window.clearTimeout(t));
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
